import { render } from "./App.vue?vue&type=template&id=ddb28f6a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ddb28f6a&lang=scss"

import exportComponent from "/home/drusso/rds-workspace/it-rds-active/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__